
<template>
  <div>
    <div 
      class="scroll-box" 
      ref="scrollBox"
      @touchstart="touchmoveChannelsHandler($event)"
      @touchmove="touchmoveChannelsHandler($event)"
      @touchend="touchmoveChannelsHandler($event)"
    >
      <div class="scroll-item" ref="scrollItem">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  

  export default {
    props: {
    },
    computed:{
    },
    data(){
      return {
        startTouchPointX:0,
        startTouchScrollLeft:0,
        maxScrollLeft:0,
        scrollMore:false,
      }
    },
    methods: {
      touchmoveChannelsHandler($event){
        if(!this.$refs || !this.$refs.scrollItem){
          console.warn('缺少$refs.scrollItem')
          return;
        }
        const type = $event.type;
        const style = this.$refs.scrollBox.style;
        if(type === 'touchstart'){
          this.startTouchPointX = $event.changedTouches[0].pageX;
          this.startTouchScrollLeft = this.$refs.scrollBox.scrollLeft;
          this.maxScrollLeft = this.$refs.scrollBox.scrollWidth - this.$refs.scrollBox.clientWidth;
        } else if(type === 'touchmove'){
          const currentMoved = this.startTouchPointX - $event.changedTouches[0].pageX;
          const currentScrollLeft = this.startTouchScrollLeft + currentMoved;
          if(currentScrollLeft < 0){
            this.$refs.scrollBox.scrollLeft = 0;
            style.removeProperty('right');
            style.left = Math.sqrt(Math.abs(currentScrollLeft)) + 'px';
          }else if(currentScrollLeft > this.maxScrollLeft){
            this.$refs.scrollBox.scrollLeft = this.maxScrollLeft;
            style.removeProperty('left');
            style.right = Math.sqrt(Math.abs(currentScrollLeft - this.maxScrollLeft)) + 'px';
          }else{
            this.$refs.scrollBox.scrollLeft = currentScrollLeft;
          }
        } else if(type === 'touchend'){
          if(style.left){
            style.left = '0px';
          }else if(style.right){
            style.right = '0px';
          }
          this.$refs.scrollBox.classList.add('smooth-back');
          setTimeout(()=>{
            if(!this.$refs || !this.$refs.scrollBox){
              return;
            }
            style.removeProperty('left');
            style.removeProperty('right');
            this.$refs.scrollBox.classList.remove('smooth-back');
          }, 300);
        }
      },
      move(px){
        if(!this.$refs || !this.$refs.scrollItem){
          console.warn('缺少$refs.scrollItem')
          // return;
        }
        let scrollLeft = this.$refs.scrollBox.scrollLeft + px;
        this.maxScrollLeft = this.$refs.scrollBox.scrollWidth - this.$refs.scrollBox.clientWidth;
        if(scrollLeft < 0){
          scrollLeft = 0;
        }else if(scrollLeft > this.maxScrollLeft){
          scrollLeft = this.maxScrollLeft
        }
        let move = scrollLeft - this.$refs.scrollBox.scrollLeft
        this.$refs.scrollBox.scrollLeft = scrollLeft;
        const style = this.$refs.scrollItem.style;
        style.left = (move) + 'px';
        setTimeout(()=>{
          this.$refs.scrollItem.classList.add('smooth-back');
          style.left = '0px';
          setTimeout(()=>{
            style.removeProperty('left');
            style.removeProperty('right');
            this.$refs.scrollItem.classList.remove('smooth-back');
          }, 300);
        },20)
      },
      getScrollLeft(){
        if(!this.$refs || !this.$refs.scrollItem){
          console.warn('缺少$refs.scrollItem')
          // return;
        }
        return this.$refs.scrollBox.scrollLeft;
      },
      calcScrollMore(){
        if(!this.$refs || !this.$refs.scrollItem){
          console.warn('缺少$refs.scrollItem')
          return;
        }
        let flag = this.scrollMore;
        this.scrollMore = this.$refs.scrollBox.scrollWidth > this.$refs.scrollBox.clientWidth;
        if(flag != this.scrollMore){

        }
      }
    },
    mounted(){
      this.$nextTick(()=>{
        this.calcScrollMore();
        this.$nextTick(()=>{
          this.$emit('scrollMoreUpdate');
        })
      });
    }
  }
</script>

<style lang="scss" scoped>
  .smooth-back{
    transition: all 0.3s ease-in-out;
  }
  .scroll-box{
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;


    .scroll-item{
      position: relative;
    }
  }
</style>
